// formatDate function will return dd-mm-yyyy for UI Indonesia
export const formatDate = (date) => {
  if (date) {
    let tempDate = new Date(date);
    return `${tempDate.getDate().toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}-${(tempDate.getMonth() + 1).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}-${tempDate.getFullYear()}`;
  } else {
    return "";
  }
};

export const formatTime = (date) => {
  if (date) {
    let tempDate = new Date(date);
    return `${tempDate.getHours().toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}:${tempDate.getMinutes().toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}:${tempDate.getSeconds().toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`;
  } else {
    return "";
  }
};

export const getDayNameIndo = (dateInput) => {
  const date = new Date(dateInput);
  return date.toLocaleDateString("id-ID", { weekday: "long" }).toUpperCase();
};

export const addSpaceEvery4 = (str) => {
  return str.replace(/(.{4})/g, "$1 ");
};
